import React, { Fragment } from "react";
import { Box, Grid } from "@mui/material";
import { GridSpg, TableSkeleton } from "@duosoftbg/nacid-components";
import NationalUniversityDataListTable from "./NationalUniversityDataListTable";
import SaveNationalUniversityDialog from "./dialog/SaveNationalUniversityDialog";
import DeleteNationalUniversityDialog from "./dialog/DeleteNationalUniversityDialog";

const NationalUniversityDataList = ({
  records,
  total,
  isLoading,
  onPageOrOrderChange,
  blockTable,
  group,
  filterFn,
}) => {
  const showTable = () => {
    return (
      <Fragment>
        <SaveNationalUniversityDialog filterFn={filterFn} />
        <DeleteNationalUniversityDialog filterFn={filterFn} records={records} total={total} />
        <NationalUniversityDataListTable
          records={records}
          total={total}
          onPageOrOrderChange={onPageOrOrderChange}
          blockTable={blockTable}
          group={group}
        />
      </Fragment>
    );
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <GridSpg item xs={12}>
          {isLoading ? <TableSkeleton /> : showTable()}
        </GridSpg>
      </Grid>
    </Box>
  );
};

export default NationalUniversityDataList;
